<table class="config-table config-container">
	<thead>
		<tr>
			<th colspan="3" class="table-heading">{{TR "Parameter"}}</th>
		</tr>
		<tr colspan="3" class="blank-row"></tr>
	</thead>
	<tbody>
		{{#each config.values}}
		<tr>
			<th>{{name}}</th>
			<td>
				<input id="{{@key}}" class="js-edit-value input-sm form-control text-right"
					type="number" step="{{step}}" value="{{SHIFT_DECIMAL 1 val}}">
			</td>
			<td class="decoration">
				<span class="input-group-addon b-0" {{#unless unit}} style="padding-left:28px;" {{/unless}}> {{unit}} </span>
			</td>
		</tr>
		{{/each}}
	</tbody>
</table>
